import getNative from './_getNative.js';
import root from './_root.js';

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

export default WeakMap;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_WeakMap.js
// module id = 1252
// module chunks = 0